export default __webpack_public_path__ + "static/media/AUCUN.3b6d5088.svg";